"use client";
import { ProgramStickyCTAProps } from "./types";
import ProgramEnrollButton from "../../../components/ProgramEnrollButton";
import StickyCTAWrapper from "@/components/StickyCTAWrapper";
import { useProgramRedesignConfig } from "@/monarch/rules/programRedesignTraffic/useProgramRedesignTraffic";
import { Skeleton } from "@/components/ui/skeleton";
import ProgramPricing from "@/components/ProgramDetailLayout/templates/components/ProgramPricing";

function Loader() {
  return (
    <>
      <Skeleton
        className="h-12 min-w-44 bg-primary-light rounded-none"
        role="status"
      />
      <Skeleton className="h-12 min-w-44 bg-primary-light" role="status" />
    </>
  );
}

export default function ProgramStickyCTA({
  programData,
  courses,
  pricingData,
  skus,
  forceShow = false,
  className,
  reactTop = 25,
}: ProgramStickyCTAProps) {
  //Calling the hook will only consume it from the context at this point, not call monarch
  const { headerCta, isLoading } = useProgramRedesignConfig();

  const showPriceInfo =
    typeof headerCta?.showPrice !== "undefined" ? headerCta?.showPrice : true;

  const pillPosition = headerCta?.pillPosition || "right";

  const ctaFlexDirection =
    pillPosition === "right" ? "flex-row" : "flex-row-reverse";

  return (
    <StickyCTAWrapper
      forceShow={forceShow}
      className={className}
      reactTop={reactTop}
    >
      <div
        className={`flex flex-col md:${ctaFlexDirection} p-4 pb-6 justify-center gap-2 md:gap-4 items-center md:h-[88px] bg-primary w-auto mx-auto`}
      >
        {isLoading ? <Loader /> : null}

        {!isLoading && showPriceInfo && pricingData ? (
          <div className="flex gap-1 text-white font-bold text-base">
            <ProgramPricing pricingData={pricingData} stackBigPrices={false} />
          </div>
        ) : null}
        {!isLoading ? (
          <div className="flex">
            <ProgramEnrollButton
              programData={programData}
              courses={courses}
              skus={skus}
            />
          </div>
        ) : null}
      </div>
    </StickyCTAWrapper>
  );
}
